/// Countdown Timer Section ///
(function() {
  'use strict';

  var countdownIntervals = [];

  function initCountdownSection(scope) {
    var container = scope || document;
    var timers = container.querySelectorAll('.countdown-timer');

    timers.forEach(function(timer) {
      if (timer.dataset.countdownInitialized === 'true') return;
      timer.dataset.countdownInitialized = 'true';

      initCountdown(timer);
    });
  }

  function cleanupCountdownSection(scope) {
    var container = scope || document;
    var timers = container.querySelectorAll('.countdown-timer');

    timers.forEach(function(timer) {
      timer.dataset.countdownInitialized = 'false';
    });

    countdownIntervals.forEach(function(intervalId) {
      clearInterval(intervalId);
    });
    countdownIntervals = [];
  }

  function initCountdown(countdown) {
    var dateStr = countdown.dataset.countdownDate;
    var timezoneOffset = parseFloat(countdown.dataset.countdownTimezone) || 0;

    if (!dateStr || !dateStr.trim()) return;

    var daysEl = countdown.querySelector('[data-days]');
    var hoursEl = countdown.querySelector('[data-hours]');
    var minutesEl = countdown.querySelector('[data-minutes]');
    var secondsEl = countdown.querySelector('[data-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function parseDate(str, tz) {
      var parts = str.split(' ');
      if (parts.length < 3) return null;

      var datePart = parts[0];
      var timePart = parts[1];
      var period = parts[2];

      if (!datePart || !timePart || !period) return null;

      var dateParts = datePart.split('-').map(Number);
      var timeParts = timePart.split(':').map(Number);

      if (dateParts.length < 3 || timeParts.length < 2) return null;

      var year = dateParts[0];
      var month = dateParts[1];
      var day = dateParts[2];
      var hours = timeParts[0];
      var minutes = timeParts[1];

      if (period.toUpperCase() === 'PM' && hours < 12) hours += 12;
      if (period.toUpperCase() === 'AM' && hours === 12) hours = 0;

      var localDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      return new Date(localDate.getTime() - tz * 60 * 60 * 1000);
    }

    var targetDate = parseDate(dateStr, timezoneOffset);
    if (!targetDate) return;

    function updateCountdown() {
      var now = new Date();
      var diff = targetDate - now;

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    var intervalId = setInterval(updateCountdown, 1000);
    countdownIntervals.push(intervalId);
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initCountdownSection();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.countdown-timer')) {
      initCountdownSection(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target.querySelector('.countdown-timer')) {
      cleanupCountdownSection(event.target);
    }
  });
})();
